import {
    NEWSLETTER_RECEIVE,
    NEWSLETTER_ERROR,
} from '../constants';
import { error as errorReducer } from './Error.reducer';

const defaultState = {
    signupComplete: false,
    errors: {},
};

export const newsletter = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case NEWSLETTER_RECEIVE:
            return {
                ...state,
                errors: {},
                ...payload,
            };
        case NEWSLETTER_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action),
            };
        default:
            return state;
    }
};
